module.exports = __webpack_public_path__ + "static/media/HighlightGoodOptimized.35785bb8.webp";